const getBgColor = color =>
  color === 'none' ? 'rgba(255, 255, 255, 0.95)' : 'rgba(251, 254, 184, 0.95)'

const style = ({ COLORS }) => ({
  container: ({ size }) => ({
    textAlign: 'center',
    padding: size(8),
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat'
  }),
  title: ({ size }) => ({
    color: COLORS.TEXT.OFF_BLACK.NORMAL,
    fontWeight: 'bold',
    lineHeight: '1.3',
    fontSize: size(8.4, { scaleFactor: 'sm' }),
    margin: '0',
    padding: `${size(1)} ${size(3)}`,
    maxWidth: '100%'
  }),
  titleTextHolder: ({ size, accessibilityColor }) => ({
    boxShadow: `${size(2)} 0 0 ${getBgColor(accessibilityColor)}`
  }),
  titleText: ({ size, accessibilityColor }) => ({
    backgroundColor: getBgColor(accessibilityColor),
    boxShadow: `${size(-2)} 0 0 ${getBgColor(accessibilityColor)}`
  }),
  dateWrapper: {
    '@media print': {
      display: 'none'
    }
  },
  date: ({ size, accessibilityColor }) => ({
    backgroundColor: getBgColor(accessibilityColor),
    color: COLORS.TEXT.MID_GREY.NORMAL,
    fontSize: size(2, { scaleFactor: 'sm' }),
    lineHeight: '1.2',
    margin: '0',
    padding: `${size(1)} ${size(2)}`,
    maxWidth: '100%'
  }),
  yearRange: ({ size }) => ({
    fontSize: size(1.4, { scaleFactor: 'sm' }),
    lineHeight: '1.2',
    backgroundColor: COLORS.DARK_BLUE.NORMAL,
    color: '#fff',
    position: 'absolute',
    right: size(4),
    top: size(4),
    padding: `${size(1)} ${size(2)}`,
    borderRadius: size(0.4)
  }),
  textHolder: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    height: '100%',
    alignItems: 'center'
  }
})

export default style
